import React from 'react';
import appConstants from '../../../../../../../appConstants';
import { withStyles } from '@material-ui/core';
import { postData } from '../../../../../../../api/componentAPIs';
import LGtrailerRequired from './LGtrailerRequired';
import IncorrectShipmentsProperty from './IncorrectShipmentProperties';
import ShipmentDistance from './ShipmentDistance';
import DuplicateCustomers from './DuplicateCustomers';

const styles = (theme) => ({
  container: {
    flex: 1
  }
});

const ValidationsContainer = ({
  classes,
  userData,
  stepsData,
  glEventHub,
  currentStep,
  IBPlanningStore,
  enqueueSnackbar
}) => {
  const updateShipmentInfo = async ({ proIdList, field, value, label }) => {
    const requestParams = {
      pros: proIdList.map((proId) => ({ proId, [field]: value })),
      scenarioId: userData.userProfile.scenarioID
    };
    const fieldLabel = label ?? field;

    try {
      const response = await postData('UpdateShipmentsProperty', requestParams);
      if (response && Math.trunc(response.status / 100) === 2) {
        enqueueSnackbar(`${fieldLabel} updated`, { variant: 'success' });
        return response;
      }
      throw new Error(`Failed to update ${fieldLabel}`);
    } catch (error) {
      handleError({ fieldLabel });
      throw error;
    }
  };

  const handleError = ({ fieldLabel, statusCode }) => {
    if (statusCode === 403) {
      return;
    }
    enqueueSnackbar(`Failed to update ${fieldLabel}`, {
      variant: 'error'
    });
  };

  const getCurrentSection = (step, stepsData) => {
    if (!stepsData?.[step]) {
      return null;
    }
    const validationStepName = stepsData[step].id;
    const currentStepData = stepsData[step]?.data;
    const currentStepMessage = stepsData[step]?.message;
    switch (validationStepName) {
      case appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.LG_TRAILER_REQUIRED:
        return (
          <LGtrailerRequired
            data={currentStepData}
            IBPlanningStore={IBPlanningStore}
            currentStepMessage={currentStepMessage}
          />
        );
      case appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.DUPLICATE_CUSTOMERS:
        return (
          <DuplicateCustomers
            data={currentStepData}
            glEventHub={glEventHub}
            currentStepMessage={currentStepMessage}
          />
        );
      case appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.INCORRECT_PSE:
        return (
          <IncorrectShipmentsProperty
            key={appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.INCORRECT_PSE}
            data={currentStepData}
            IBPlanningStore={IBPlanningStore}
            updateShipmentInfo={updateShipmentInfo}
            enqueueSnackbar={enqueueSnackbar}
            currentStepMessage={currentStepMessage}
            isIncorrectPSE
          />
        );
      case appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.LATE_SHIPMENTS:
        return (
          <IncorrectShipmentsProperty
            key={appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.LATE_SHIPMENTS}
            data={currentStepData}
            IBPlanningStore={IBPlanningStore}
            updateShipmentInfo={updateShipmentInfo}
            currentStepMessage={currentStepMessage}
            enqueueSnackbar={enqueueSnackbar}
          />
        );
      case appConstants.DYNAMIC_ROUTING_VALIDATION_STEPS.SHIPMENT_DISTANCE:
        return (
          <ShipmentDistance
            data={currentStepData}
            IBPlanningStore={IBPlanningStore}
            glEventHub={glEventHub}
            userData={userData}
            currentStepMessage={currentStepMessage}
          />
        );
      default:
        return null;
    }
  };

  return <div className={classes.container}>{getCurrentSection(currentStep, stepsData)}</div>;
};

export default withStyles(styles)(ValidationsContainer);
